import {
  rankWith,
  and,
  schemaMatches,
  uiTypeIs,
} from "@jsonforms/core";
import React, { useState } from "react";
import { withJsonFormsControlProps } from '@jsonforms/react';
import {
  IconButton,
  Typography,
  Box,
  Autocomplete,
  TextField,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
const ArrayEnumDropdownWithSortUI = ({
  data = [],
  handleChange,
  path,
  schema,
}) => {
  const [pendingDeleteIndex, setPendingDeleteIndex] = useState(null);
  const safeData = Array.isArray(data) ? data : [];
  const options = Array.isArray(schema?.items?.enum) ? schema.items.enum : [];
  const title = schema.title ?? path.split(".").pop();
  const addItem = () => {
    const newData = [...safeData, ""]; // empty entry
    handleChange(path, newData);
  };

  const removeItem = (index) => {
    const arr = [...safeData];
    arr.splice(index, 1);
    handleChange(path, arr);
  };

  const move = (from, to) => {
    const arr = [...safeData];
    const val = arr.splice(from, 1)[0];
    arr.splice(to, 0, val);
    handleChange(path, arr);
  };

  const updateValue = (index, newValue) => {
    const arr = [...safeData];
    arr[index] = newValue;
    handleChange(path, arr);
  };
  const openConfirmDelete = (index) => setPendingDeleteIndex(index);
  const closeConfirmDelete = () => setPendingDeleteIndex(null);
  const confirmDelete = () => {
    if (pendingDeleteIndex !== null) {
      removeItem(pendingDeleteIndex);
      setPendingDeleteIndex(null);
    }
  };
  return (
    <Box sx={{ width: "100%", p: 1 }}>
      {/* Header row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">{title}</Typography>

        <IconButton onClick={addItem}>
          <AddIcon />
        </IconButton>
      </Box>

      {/* Each entry */}
      <Stack spacing={0}>
        {safeData.length > 0 && safeData.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              borderTop: "1px solid #ddd",
              p: 1
            }}
          >
            {/* Autocomplete */}
            <Autocomplete
              options={options}
              value={item || ""}
              onChange={(e, v) => updateValue(index, v)}
              renderInput={(params) => (
                <TextField {...params} label="" variant="outlined" />
              )}
              sx={{ flex: 1 }}
            />

            {/* Move Up */}
            <IconButton
              disabled={index === 0}
              onClick={() => move(index, index - 1)}
            >
              <ArrowUpwardIcon />
            </IconButton>

            {/* Move Down */}
            <IconButton
              disabled={index === safeData.length - 1}
              onClick={() => move(index, index + 1)}
            >
              <ArrowDownwardIcon />
            </IconButton>

            {/* Delete */}
            <IconButton onClick={() => openConfirmDelete(index)}>
              <DeleteIcon />
            </IconButton>
          </Box>
        ))}
      </Stack>
      <Dialog open={pendingDeleteIndex !== null} onClose={closeConfirmDelete}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete the selected entry?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirmDelete}>No</Button>
          <Button onClick={confirmDelete} autoFocus>Yes</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export const ArrayEnumDropdownRenderer =
  withJsonFormsControlProps(ArrayEnumDropdownWithSortUI);

export const arrayOfPrimitiveEnumTester = rankWith(
  101, // higher so array enum wins over primitive enum
  and(
    uiTypeIs("Control"),
    schemaMatches((schema) => {
      const isArrayOfPrimitiveEnum =
        schema &&
        schema.type === "array" &&
        schema.items &&
        ["string", "number", "integer", "boolean"].includes(
          schema.items.type
        ) &&
        Array.isArray(schema.items.enum);
      return isArrayOfPrimitiveEnum;
    })
  )
);
